import * as React from "react"
import type { SVGProps } from "react"
const SvgBoltFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 15H5.9q-.6 0-.89-.54a.9.9 0 0 1 .06-1.03l7.48-10.75q.25-.35.65-.5.4-.12.83.02.42.15.62.53.2.37.15.8L14 10h3.88q.64 0 .9.58.27.57-.16 1.07L10.4 21.5q-.26.33-.68.43-.4.1-.77-.08a1.3 1.3 0 0 1-.75-1.32z" />
  </svg>
)
export default SvgBoltFilled
